import React from 'react';
import * as MuiIcons from '@material-ui/icons';

export type IconNames = keyof typeof MuiIcons;

export const getIconByName = (iconName: IconNames, props: any) => {
	const Icon = MuiIcons[iconName];
	return <Icon {...props} />;
};
